export const APP_NAME = 'Bananas Proptech'
export const PERSIST_STORE_NAME = 'bananas_lessor_admin_v00182'
export const REDIRECT_URL_KEY = 'redirectUrl'